import FractionDsnNumero from '@/generated/controls/fractionDsn/FractionDsnNumero.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: FractionDsnNumero
})

